export enum PaytronixGiftAuthSource {
  Direct = 'direct',
  Olo = 'olo',
}
